import React, { useContext } from "react";
import { LanguageContext } from "../../context/LanguageContext";

function InvitesPanelBase({ title, pendingInvites, readOnly, onAccept, onReject }) {
  const { t } = useContext(LanguageContext);

  return (
    <div
      style={{
        margin: "0 0 16px 0",
        padding: 12,
        border: "1px solid var(--color-border)",
        borderRadius: 16,
        background:
          "linear-gradient(180deg, rgba(255,255,255,0.04) 0%, rgba(255,255,255,0.02) 100%)",
        boxShadow: "0 8px 28px rgba(0,0,0,.22)",
        boxSizing: "border-box",
      }}
    >
      <h3 style={{ margin: "0 0 10px 0" }}>{title}</h3>

      <ul
        style={{
          listStyle: "none",
          padding: 0,
          margin: 0,
          display: "flex",
          flexDirection: "column",
          gap: 8,
        }}
      >
        {pendingInvites.map((sender) => (
          <li
            key={sender}
            style={{
              display: "flex",
              flexWrap: "wrap",
              alignItems: "center",
              gap: 10,
              padding: "10px 12px",
              border: "1px solid var(--color-border)",
              borderRadius: 14,
              background: "transparent",
              boxSizing: "border-box",
            }}
          >
            <span
              title={sender}
              style={{
                flex: "1 1 200px",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                fontWeight: 600,
                minWidth: 0,
              }}
            >
              {sender}
            </span>

            {!readOnly && (
              <>
                <button
                  type="button"
                  className="btn-secondary"
                  style={{
                    padding: "4px 10px",
                    borderRadius: 10,
                    fontWeight: 700,
                    fontSize: 14,
                    lineHeight: 1.2,
                  }}
                  onClick={() => onAccept(sender)}
                >
                  {t("invites.accept")}
                </button>

                <button
                  type="button"
                  className="btn-secondary"
                  style={{
                    padding: "4px 10px",
                    borderRadius: 10,
                    fontWeight: 700,
                    fontSize: 14,
                    lineHeight: 1.2,
                    opacity: 0.9,
                  }}
                  onClick={() => onReject(sender)}
                >
                  {t("invites.reject")}
                </button>
              </>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}

export function InvitesPanel({ pendingInvites, readOnly, onAccept, onReject }) {
  const { t } = useContext(LanguageContext);
  return (
    <InvitesPanelBase
      title={t("invites.parentsTitle")}
      pendingInvites={pendingInvites}
      readOnly={readOnly}
      onAccept={onAccept}
      onReject={onReject}
    />
  );
}

export function InvitesTutorPanel({ pendingInvites, readOnly, onAccept, onReject }) {
  const { t } = useContext(LanguageContext);
  return (
    <InvitesPanelBase
      title={t("invites.tutorsTitle")}
      pendingInvites={pendingInvites}
      readOnly={readOnly}
      onAccept={onAccept}
      onReject={onReject}
    />
  );
}

export function ParentsList({ parents }) {
  const { t } = useContext(LanguageContext);
  return (
    <div
      style={{
        marginTop: 10,
        padding: "10px",
        border: "1px solid var(--color-border)",
        borderRadius: 6,
        backgroundColor: "rgba(0,0,0,0.05)",
        boxSizing: "border-box",
      }}
    >
      <h3>{t("invites.assignedParents")}</h3>
      <ul>
        {parents.map((parent) => (
          <li key={parent}>{parent}</li>
        ))}
      </ul>
    </div>
  );
}
